import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)`
  width: 100%;
  height: 100vh;
  overflow: auto;
`;
